import React from "react";
import './waterconservation.css';
import img1 from '../../assets/water1.jpeg'; // Replace with your image paths
import img2 from '../../assets/water2.JPG';
import img3 from '../../assets/water3.jpg';
import img4 from '../../assets/water4.jpg';
import img5 from '../../assets/water5.JPG';

const WaterConservation = () => {
  return (
    <div className="water-conservation-section">
      {/* Banner Section */}
      <div className="banner">
        <img src={img2} alt="Banner" />
        <h2>Sustainable Water Conservation at Salaiban</h2>
      </div>

      {/* Introduction Paragraph */}
      <div className="intro">
        <p>
          The ecological project <strong>Salaiban</strong>, located at the foothills of the Satpuda range on the Maharashtra-Madhya Pradesh border, began in 2015 as a response to recurring droughts. Spearheaded by the <strong>Tarunai Foundation</strong>, the project emphasizes five principles: <b>water, forest, land, animals, and people.</b> Through extensive efforts, Salaiban has become a model for sustainable water conservation, transforming from a drought-stricken area into a thriving ecosystem.
        </p>
      </div>

      {/* Key Initiatives Section */}
      <div className="key-initiatives">
        <h3>Key Initiatives in Water Conservation</h3>
        <ol>
          <li>
            <strong>Shram Sanskar Camps (2015-2017):</strong>
            <ul>
              <li>Organized under the campaign "Zunj Dushkalashi."</li>
              <li>Hundreds of volunteers from across Maharashtra participated in building Forest Dams, Earthen Dams, Continuous Level Trenches, and conducting extensive tree plantations.</li>
            </ul>
          </li>
          <li>
            <strong>Participation in Water Cup (2018):</strong>
            <ul>
              <li>
                With encouragement from the <strong>Pani Foundation</strong>, nearby villages such as <b>Sungaon, Bandapimpal, Vadpani,</b> and <b>Chalthana</b> took part.
              </li>
              <li>
                Villagers, particularly from the tribal hamlets of Bandapimpal and Vadpani, worked tirelessly for two months during the summer to construct:
                <ul>
                  <li><b>Earthen Dams</b></li>
                  <li><b>Stone Bunds</b></li>
                  <li><b>Continuous Contour Trenches</b></li>
                </ul>
              </li>
              <li>
                These efforts earned Bandapimpal-Vadpani a <strong>top 10 position</strong> out of 4,500 participating villages, along with state-level recognition, a <strong>Water Cup Award,</strong> and a cash prize of <b>₹10 lakh.</b>
              </li>
            </ul>
          </li>
          <li>
            <strong>Infrastructure Development:</strong>
            <ul>
              <li>Built <b>8 earthen dams</b> with a combined storage capacity of almost<b>40 lakh liters</b> of water.</li>
              <li>Constructed <b>two cement dams</b> and a large village lake with a capacity of <b>6 crore liters,</b> enhancing water availability.</li>
              <li>Implemented the <strong>Jalyukta Shivar Yojana</strong> in collaboration with <strong>Art of Living</strong> and <strong>Bharatiya Jain Sanghatana</strong> to deepen drains and desilt dams, enabling the recharge of <b>10 crore liters of rainwater annually.</b></li>
            </ul>
          </li>
          <li>
            <strong>Future Plans:</strong>
            <ul>
              <li>Integration of all existing dams within the Salaiban area for improved water management.</li>
              <li>Financial assistance is sought to scale up these efforts and ensure long-term sustainability.</li>
            </ul>
          </li>
        </ol>
      </div>

      {/* Images Section */}
      <div className="image-grid">
        <div className="image-item">
          <img src={img5} alt="Earthen Dams" />
          <p>Earthen Dams for Water Storage</p>
        </div>
        <div className="image-item">
          <img src={img3} alt="Stone Bunds" />
          <p>Continuous Contour Trenches</p>
        </div>
        <div className="image-item">
          <img src={img1} alt="Village Lake" />
          <p>Fish Farming in Restored Water Bodies</p>
        </div>
        <div className="image-item">
          <img src={img4} alt="Fish Farming" />
          <p>Extensive Tree Plantations</p>
        </div>
      </div>

      {/* Video Section */}
      <div className="video-section">
        <h3>Watch Our Journey</h3>
        <iframe
 
          src="https://www.youtube.com/embed/0KnmOYHX7SA?si=tDQbH0oIhABIE6bl"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      {/* Results Section */}
      <div className="results">
        <h3>Visible Results and Impact</h3>
        <ol>
          <li><strong>Drought Eradication:</strong> Salaiban has become drought-free, with rising groundwater levels.</li>
          <li>
            <strong>Agricultural Transformation:</strong>
            <ul>
              <li>Availability of water throughout the year has enabled farmers to grow <b>two crops annually.</b></li>
              <li>Increased interest in <b>orchard and vegetable farming</b> has improved productivity and profitability for local farmers, particularly tribal and Dalit communities.</li>
            </ul>
          </li>
          <li>
            <strong>Economic Growth:</strong>
            <ul>
              <li><b>Fish farming</b> in the village pond has created employment opportunities for villagers.</li>
              <li>The sustainable practices are contributing to an overall improvement in living standards.</li>
            </ul>
          </li>
          <li>
            <strong>Biodiversity Revival:</strong>
            <ul>
              <li>The conservation efforts have led to an increase in migratory aquatic species and birds, enhancing the area's ecological richness.</li>
            </ul>
          </li>
          <li>
            <strong>Potential for Eco Tourism:</strong>
            <ul>
              <li>With its restored water bodies, lush greenery, and rising biodiversity, Salaiban holds great potential as a future <b>eco-tourism destination.</b></li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default WaterConservation;
